import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { cn } from '../../../lib/utils';
import { SpecraActionRow } from '../lieutenants/action-row';
/** Prioritized work queue extracted from the Delivery "Do Next" pattern. */ export const SpecraActionList = /*#__PURE__*/ React.forwardRef(({ className, getItemProps, getItemTestId, items, renderLink, trailing, ...props }, ref)=>/*#__PURE__*/ _jsx("div", {
        className: cn('divide-y divide-border', className),
        ref: ref,
        ...props,
        children: items.map((item)=>/*#__PURE__*/ _jsx(SpecraActionRow, {
                ...getItemProps?.(item),
                "data-item-id": item.id,
                "data-testid": getItemTestId?.(item),
                item: item,
                renderLink: renderLink,
                trailing: trailing
            }, item.id))
    }));
SpecraActionList.displayName = 'SpecraActionList';
